import { TemplatesSections } from "@/pages/talent/templates/templates-sections.ts";
import { ApiFormTemplate } from "@/types/forms/form-template.types.ts";
import { ConfirmationModal, useModals } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export enum PerformanceReviewTemplateEditPageStep {
  details = "details",
  questions = "questions",
}

export interface TemplateEditPageProps {
  template: ApiFormTemplate;
}

export const useTemplateEditPage = () => {
  const { openModal } = useModals();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const exit = async function () {
    navigate(`/templates/${TemplatesSections.performanceReviews}`);
  };

  const confirmExit = () => {
    openModal(ConfirmationModal, {
      question: t("common:unsaved_changes_may_be_lost_title"),
      text: t("common:unsaved_changes_may_be_lost_description"),
      acceptTitle: t("common:leave"),
      secondButtonTitle: t("common:stay"),
      onAccept: exit,
    });
  };

  const navigateToStep = (id: number, newStep: PerformanceReviewTemplateEditPageStep) => {
    navigate(`/templates/performance-reviews/${id}/setup/${newStep}`);
  };

  return {
    exit,
    confirmExit,
    navigateToStep,
  };
};
